
(() => {
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-qty-value], input[type="number"]');
      if (!this.input) return;

      this.addEventListener('click', (e) => {
        const minus = e.target.closest('[data-qty-minus]');
        const plus = e.target.closest('[data-qty-plus]');
        if (!minus && !plus) return;
        e.preventDefault();
        this.step(plus ? 1 : -1);
      });

      this.input.addEventListener('change', () => this.commit(this.value));
    }

    get value() { return parseInt(this.input.value, 10) || 0; }
    get min() { return this.input.min !== '' ? parseInt(this.input.min, 10) : 0; }
    get max() { return this.input.max !== '' ? parseInt(this.input.max, 10) : Infinity; }
    get stepSize() { return parseInt(this.input.step, 10) || 1; }

    step(direction) {
      this.commit(this.value + direction * this.stepSize);
    }

    commit(next) {
      const clamped = Math.min(this.max, Math.max(this.min, next));
      const changed = clamped !== parseInt(this.input.dataset.lastValue ?? this.input.defaultValue, 10);
      this.input.value = clamped;
      this.input.dataset.lastValue = clamped;
      this.querySelector('[data-qty-minus]')?.toggleAttribute('disabled', clamped <= this.min);
      this.querySelector('[data-qty-plus]')?.toggleAttribute('disabled', clamped >= this.max);
      if (changed) {
        this.dispatchEvent(new CustomEvent('quantity:change', {
          bubbles: true,
          detail: { value: clamped, line: this.dataset.line, key: this.dataset.key },
        }));
      }
    }
  }

  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
})();
